export default __webpack_public_path__ + "static/media/master-class-4.8458bc06.jpeg";